export default "__VITE_ASSET__DGeK8jtV__"